import { media } from 'common/responsive';
import Image from './Image';

const DesksImage = Image.extend`
  width: 110%;
  left: -5%;
  top: 10%;
  
  ${media.tablet`
    max-width: 90%;
    top: 0;
    left: 5%;
  `}
  
  ${media.desktop`
    top: 15%;
    max-width: 670px;
    left: 0;
  `}
`;

export default DesksImage;



// WEBPACK FOOTER //
// ./src/kentico-blocks/HeroImage/ImageBlock/DesksImage.jsx